
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/zendesk",
      function () {
        return require("private-next-pages/destinations/zendesk.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/zendesk"])
      });
    }
  